module.exports = __webpack_public_path__ + "static/media/ic-username.368b0802.svg";